import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';

import { storeContext } from '../../../../../context';
import OfferItemSideBar from './OfferItemSideBar';
import OfferItemFooter from './OfferItemFooter';

const OfferItem = observer(({ isFooterDisplay = false }) => {
  const {
    payable,
    translations: { currentLanguage }
  } = useContext(storeContext);

  const {
    selectableNextPayment,
    limitedOffer,
    limitedOfferPaymentAmount,
    isLoadingOffer
  } = payable;

  const hasValidOffer = limitedOffer > 1 && selectableNextPayment;
  const props = {
    hasValidOffer,
    duration: limitedOffer,
    isLoadingOffer,
    limitedOfferPaymentAmount
  };

  return (
    <>
      {isFooterDisplay ? (
        <OfferItemFooter {...props} />
      ) : (
        <OfferItemSideBar {...props} />
      )}
    </>
  );
});

export default OfferItem;
